import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	setNewFieldTypeHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.set-new-field-type-heading',
		defaultMessage: 'Create a new custom field',
		description: 'Header for section in dropdown menu to create a new field',
	},
	setNewFieldTypeDescription: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.set-new-field-type-description',
		defaultMessage: "Add a field with information specific to your team's needs.",
		description: 'Header for section in dropdown menu to create a new field',
	},
	learnMoreLink: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.learn-more-link',
		defaultMessage: 'Learn more about creating custom fields',
		description: 'Learn more about create custom fields link',
	},
	existingFieldSectionHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.existing-field-section-heading',
		defaultMessage: 'Map to an existing field',
		description: 'Header for section in dropdown menu to map to a reusable jira field',
	},
	issueLinksFieldSectionHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.issue-links-field-section-heading',
		defaultMessage: 'Link Issues',
		description: 'Header for section in dropdown menu to map to a issue link field',
	},
	goBack: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.go-back',
		defaultMessage: 'Go back',
		description: 'Button text to return to go back to main menu',
	},
	selectCustomFieldHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.select-custom-field-heading',
		defaultMessage: 'Select custom field',
		description: 'Header for dropdown menu to select custom field type',
	},
	selectCustomFieldDescription: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.select-custom-field-description',
		defaultMessage:
			'The type indicates how your custom field will display and function, as well as what values it can accept.',
		description: 'Description for dropdown menu to select custom field type',
	},
	newField: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.new-field',
		defaultMessage: 'New Field',
		description: 'Label for lozenge to indicate this column will create a new field',
	},
	removeField: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.remove-field',
		defaultMessage: 'Exclude column data from your import',
		description: 'Button text to return to remove field from import',
	},
	mapToAField: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.map-to-a-field',
		defaultMessage: 'Map to a field',
		description: 'Button text to get the user to map a field to the column',
	},
});
